import React from "react";

const Navbar = ({ handleButtonClick, handleToggleMenu, selectedDropdownOption, handleDropdownOptionChange }) => {
    const handleClick = (buttonName) => {
        handleButtonClick(buttonName);
    };

    return (
        <nav className="sticky  top-0  flex  items-center  px-2  bg-white">
          
            <button type="button" onClick={handleToggleMenu} className="p-2">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                        stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 9h16.5m-16.5 6.75h16.5"/>
                </svg>
            </button>
       
            <button className="p-2" type="button" onClick={() => handleClick("releaseNotes")}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5  p-0.5">
                    <path fillRule="evenodd" d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z" clipRule="evenodd" />
                </svg>
            </button>
            
            <button className="p-2 	align-content: flex-end;" type="button"  onClick={() =>  window.open("https://www.patreon.com/TempleofallKnowledge")}>
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path fill="currentColor" d="M0 .48v23.04h4.22V.48zm15.385 0c-4.764 0-8.641 3.88-8.641 8.65c0 4.755 3.877 8.623 8.641 8.623c4.75 0 8.615-3.868 8.615-8.623C24 4.36 20.136.48 15.385.48z"/></svg>
            </button> 
            
            <button className="p-2 	align-content: flex-end;" type="button"  onClick={() =>  window.open("https://discord.gg/SVjUb93FqB")}>
                <svg width="20" height="20" viewBox="-1 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill="currentColor" d="M15.45 0c1.118 0 2.031.901 2.05 2.025V20l-2.15-1.9-1.21-1.12-1.28-1.19.53 1.85H2.05A2.055 2.055 0 0 1 0 15.615V2.06C0 .932.901.019 2.015 0H15.45ZM7.32 4.78l-.1-.12h-.057c-.273.009-1.486.1-2.753 1.05l-.048.092c-.251.49-1.392 2.872-1.392 5.738l.02.033c.142.217 1.019 1.423 3.03 1.487l.295-.361.375-.469c-1.166-.349-1.666-1.051-1.74-1.164l-.01-.016.041.027c.045.03.127.08.239.143.01.01.02.02.04.03.03.02.06.03.09.05.25.14.5.25.73.34.41.16.9.32 1.47.43.729.136 1.58.187 2.508.025l.082-.015c.47-.08.95-.22 1.45-.43.35-.13.74-.32 1.15-.59l-.016.025c-.096.14-.62.833-1.794 1.165l.165.207c.253.314.495.603.495.603 2.21-.07 3.06-1.52 3.06-1.52 0-3.22-1.44-5.83-1.44-5.83-1.238-.929-2.425-1.037-2.733-1.049L10.4 4.66l-.14.16c1.508.461 2.3 1.103 2.46 1.243l.03.027a8.152 8.152 0 0 0-5.03-.94c-.06 0-.11.01-.17.02l-.056.005c-.38.039-1.197.179-2.214.625l-.145.068c-.182.086-.314.153-.385.19l-.06.032s.813-.774 2.576-1.294l.054-.016Zm-.38 3.61c.57 0 1.03.5 1.02 1.11 0 .61-.45 1.11-1.02 1.11-.56 0-1.02-.5-1.02-1.11 0-.61.45-1.11 1.02-1.11Zm3.65 0c.57 0 1.02.5 1.02 1.11 0 .61-.45 1.11-1.02 1.11-.56 0-1.02-.5-1.02-1.11 0-.61.45-1.11 1.02-1.11Z"/>
                </svg>

            </button>

            <div className="flex  uppercase  text-xs  font-medium">
                <button type="button" className="p-2" onClick={() => handleClick("stratagems")}>
                    Stratagems
                </button>
            </div>
        </nav>
    );
};

export default Navbar;
